import axios from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_CONTENT_URL ?? `${hostConfig.apiBaseUrl}/content-service`;

class ContentService {
  downloadContent(id, filepath) {
    return axios
      .get(baseUrl + "/content/download/" + id, {
        responseType: "blob",
      })
      .then((response) => {
        console.log(response.data);
        var blob = new Blob([response.data], {
          type: "application/octet-stream",
        });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = filepath.substring(filepath.lastIndexOf("/") + 1);
        console.log(filepath);
        console.log(fileName);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log("Error!", error.response);
        return error;
      });
  }

  createContent(attachment, version = 1) {
    let formData = new FormData();
    formData.append("name", attachment.name);
    formData.append("description", attachment.description);
    formData.append("category", attachment.category);
    formData.append("fileName", attachment.fileName);
    formData.append("fileSize", attachment.fileSize);
    formData.append("type", attachment.type != undefined ? attachment.type : null);
    formData.append(
      "generateSignedUrl",
      attachment.generateSignedUrl != undefined ? attachment.generateSignedUrl : false
    );
    //only attach the file if it's not a video, but sending up a video will ruin your life
    if (attachment.type != null && attachment.type != "video") {
      formData.append("file", attachment.file);
    }

    if (attachment.clientId !== undefined) {
      formData.append("clientId", attachment.clientId);
    }
    console.log(baseUrl, attachment);
    return axios
      .post(baseUrl + "/content", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        return response.data.content;
      })
      .catch((error) => {
        console.log("Error!", error);
        if (version == 1) return error;
        else throw error;
      });
  }

  createPublicContent(file, context, clientId) {
    let formData = new FormData();
    formData.append("Image", file);
    formData.append("context", context);
    if (clientId !== undefined && clientId !== null && clientId !== "") {
      formData.append("clientId", clientId);
    }

    return axios
      .post(baseUrl + "/v2/content/public", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        throw error?.response?.data || error;
      });
  }

  getAllContent(version = 1) {
    return axios
      .get(baseUrl + "/content")
      .then((response) => {
        return response.data.content;
      })
      .catch((error) => {
        console.log("Error!", error.response);

        if (version == 1) return error;
        else throw error;
      });
  }
  getContent(contentId) {
    return axios
      .get(baseUrl + "/content/" + contentId)
      .then((response) => {
        return response.data.content;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        return error;
      });
  }

  uploadContentWithSignedUrl(
    url,
    attachment,
    version = 1,
    includeContentLength = false,
    contentType = "application/octet-stream"
  ) {
    const headers = {
      "Content-Type": contentType,
    };
    if (includeContentLength) headers["X-Upload-Content-Length"] = attachment.size;
    return axios
      .put(url, attachment, {
        headers,
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        if (version == 1) return error;
        else throw error;
      });
  }

  encodeFile(url, type, version = 1) {
    return axios
      .post(baseUrl + "/content/encode", {
        url: url,
        type: type,
      })
      .then((response) => {
        // console.log(response);
        return response.data.jobId;
      })
      .catch((error) => {
        console.log("Error!", error);
        if (version == 1) return error;
        else throw error;
      });
  }

  refreshFileEncodingStatus() {
    return axios
      .get(baseUrl + "/content/encode/status")
      .then((response) => {
        // console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }

  getSignedUrlBasedOnContentId(contentId, version = 1) {
    return axios
      .get(baseUrl + "/content/signedUrl/" + contentId)
      .then((response) => {
        // console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        if (version == 1) return error;
        else throw error;
      });
  }

  getSignedUrlForViewingContent(url, version = 1) {
    console.log(baseUrl + "/" + url);
    return axios
      .get(baseUrl + "/" + url)
      .then((response) => {
        // console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        if (version == 1) return error;
        else throw error;
      });
  }

  replaceContent(contentId, file) {
    let formData = new FormData();
    formData.append("file", file);

    return axios
      .put(baseUrl + "/content/" + contentId, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data.result;
      })
      .catch((error) => {
        console.log("Error replacing content!", error);
        throw error?.response?.data || error;
      });
  }

  deleteContent(contentId) {
    return axios
      .delete(baseUrl + "/content/" + contentId)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error deleting content!", error);
        throw error?.response?.data || error;
      });
  }
}

export default new ContentService();
